import { Link } from 'react-router-dom';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';

export default function ServicesPage() {
  const services = [
    {
      icon: 'ri-smoking-line',
      title: 'خدمة الإقلاع عن التدخين',
      description: 'برنامج متكامل للإقلاع عن التدخين يشمل العلاج الدوائي والسلوكي مع متابعة دورية لضمان النجاح والوقاية من الانتكاسة',
      features: [
        'تقييم شامل لمستوى الإدمان',
        'خطة علاجية مخصصة',
        'أدوية مساعدة على الإقلاع',
        'متابعة أسبوعية'
      ],
      color: 'from-primary to-primary-600',
      image: 'https://public.readdy.ai/ai/img_res/0569015cf7b0ae814385c67335eb0900.jpg'
    },
    {
      icon: 'ri-stethoscope-line',
      title: 'الاستشارات الطبية',
      description: 'استشارات طبية متخصصة مع أطباء معتمدين في علاج الإدمان والطب النفسي لتقييم حالتك ووضع خطة علاجية مناسبة',
      features: [
        'استشارة طبية شاملة',
        'تقييم الحالة الصحية',
        'وضع خطة علاجية',
        'متابعة مستمرة'
      ],
      color: 'from-secondary to-secondary-600',
      image: 'https://readdy.ai/api/search-image?query=Medical%20consultation%20room%2C%20doctor%20consulting%20with%20patient%2C%20professional%20healthcare%20setting%2C%20clinical%20consultation%2C%20medical%20advice%2C%20healthcare%20professional%2C%20compassionate%20medical%20care&width=600&height=400&seq=service-consultation-001&orientation=landscape'
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'المتابعة الدورية',
      description: 'متابعة مستمرة لحالتك الصحية وتقدمك في رحلة الإقلاع مع جلسات دورية للتأكد من عدم الانتكاسة',
      features: [
        'جلسات متابعة شهرية',
        'تقييم التقدم',
        'تعديل الخطة العلاجية',
        'دعم مستمر'
      ],
      color: 'from-accent to-accent-600',
      image: 'https://readdy.ai/api/search-image?query=Medical%20follow-up%20appointment%2C%20doctor%20reviewing%20patient%20progress%2C%20healthcare%20monitoring%2C%20clinical%20checkup%2C%20medical%20assessment%2C%20professional%20healthcare%2C%20patient%20care&width=600&height=400&seq=service-followup-001&orientation=landscape'
    },
    {
      icon: 'ri-mental-health-line',
      title: 'العلاج السلوكي',
      description: 'جلسات علاج سلوكي معرفي لتغيير العادات المرتبطة بالتدخين وتطوير استراتيجيات للتعامل مع الرغبة في التدخين',
      features: [
        'جلسات علاج سلوكي',
        'تقنيات التعامل مع الرغبة',
        'تغيير العادات',
        'بناء عادات صحية'
      ],
      color: 'from-primary-600 to-secondary',
      image: 'https://readdy.ai/api/search-image?query=Behavioral%20therapy%20session%2C%20therapist%20counseling%20patient%2C%20psychological%20support%2C%20mental%20health%20care%2C%20therapy%20consultation%2C%20professional%20counseling%2C%20supportive%20healthcare&width=600&height=400&seq=service-behavioral-001&orientation=landscape'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'الدعم النفسي',
      description: 'دعم نفسي متخصص للتعامل مع التحديات النفسية أثناء الإقلاع مثل القلق والتوتر والاكتئاب',
      features: [
        'جلسات دعم نفسي',
        'علاج القلق والتوتر',
        'تقنيات الاسترخاء',
        'دعم عاطفي'
      ],
      color: 'from-secondary-600 to-accent',
      image: 'https://readdy.ai/api/search-image?query=Psychological%20support%20session%2C%20mental%20health%20counseling%2C%20emotional%20support%2C%20therapy%20consultation%2C%20compassionate%20care%2C%20professional%20psychological%20help%2C%20supportive%20healthcare&width=600&height=400&seq=service-psychological-001&orientation=landscape'
    },
    {
      icon: 'ri-team-line',
      title: 'الدعم الجماعي',
      description: 'جلسات دعم جماعية مع مرضى آخرين في نفس الرحلة لتبادل التجارب والدعم المتبادل',
      features: [
        'جلسات جماعية أسبوعية',
        'تبادل التجارب',
        'دعم متبادل',
        'بناء شبكة دعم'
      ],
      color: 'from-accent-600 to-primary',
      image: 'https://readdy.ai/api/search-image?query=Group%20therapy%20session%2C%20support%20group%20meeting%2C%20people%20supporting%20each%20other%2C%20group%20counseling%2C%20community%20support%2C%20shared%20experiences%2C%20collaborative%20healing&width=600&height=400&seq=service-group-001&orientation=landscape'
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-24">
        {/* Hero Section */}
        <section className="relative py-20 bg-gradient-to-br from-primary to-secondary text-white overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-10 right-10 w-64 h-64 bg-white rounded-full blur-3xl"></div>
            <div className="absolute bottom-10 left-10 w-96 h-96 bg-accent rounded-full blur-3xl"></div>
          </div>
          <div className="container mx-auto px-4 relative z-10">
            <div className="max-w-4xl mx-auto text-center animate-fade-in">
              <h1 className="text-5xl md:text-6xl font-bold mb-6">خدماتنا الطبية</h1>
              <p className="text-xl md:text-2xl text-white/90 leading-relaxed">
                نقدم <strong>برامج علاجية متكاملة</strong> لمساعدتك على الإقلاع عن التدخين
              </p>
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <div className="space-y-16 max-w-7xl mx-auto">
              {services.map((service, index) => (
                <div
                  key={index}
                  className={`grid md:grid-cols-2 gap-12 items-center animate-slide-up ${
                    index % 2 === 1 ? 'md:flex-row-reverse' : ''
                  }`}
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className={index % 2 === 1 ? 'md:order-2' : ''}>
                    <div className="rounded-2xl overflow-hidden shadow-2xl">
                      <img
                        src={service.image}
                        alt={service.title}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </div>

                  <div className={index % 2 === 1 ? 'md:order-1' : ''}>
                    <div className={`w-16 h-16 bg-gradient-to-br ${service.color} rounded-xl flex items-center justify-center mb-6 shadow-lg`}>
                      <i className={`${service.icon} text-white text-3xl`}></i>
                    </div>
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">{service.title}</h2>
                    <p className="text-gray-600 leading-relaxed text-lg mb-6">{service.description}</p>
                    
                    <div className="space-y-3 mb-8">
                      {service.features.map((feature, idx) => (
                        <div key={idx} className="flex items-center gap-3">
                          <div className="w-6 h-6 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
                            <i className="ri-check-line text-primary text-sm"></i>
                          </div>
                          <span className="text-gray-700">{feature}</span>
                        </div>
                      ))}
                    </div>

                    <Link
                      to="/consultation"
                      className="inline-flex items-center gap-2 bg-primary text-white px-8 py-4 rounded-lg font-medium hover:bg-primary-600 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                    >
                      <span>اطلب الخدمة الآن</span>
                      <i className="ri-arrow-left-line"></i>
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-br from-primary to-secondary text-white">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center animate-fade-in">
              <h2 className="text-4xl md:text-5xl font-bold mb-6">هل أنت مستعد للبدء؟</h2>
              <p className="text-xl text-white/90 mb-8 leading-relaxed">
                ابدأ رحلة الإقلاع اليوم مع <strong>فريقنا الطبي المتخصص</strong>
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link
                  to="/consultation"
                  className="inline-flex items-center gap-2 bg-white text-primary px-8 py-4 rounded-lg font-medium hover:bg-white/90 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-calendar-check-line"></i>
                  <span>احجز استشارة مجانية</span>
                </Link>
                <Link
                  to="/contact"
                  className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border-2 border-white text-white px-8 py-4 rounded-lg font-medium hover:bg-white hover:text-primary transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-phone-line"></i>
                  <span>تواصل معنا</span>
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}